/**
 * Product-page postcode delivery widget (inline — no modal).
 * ------------------------------------------------------------------
 * Renders a "Delivered to {State postcode}" header above a search box.
 * Typing digits filters the store's served postcodes in a dropdown; picking
 * one (or pressing Enter with an exact match) computes the Standard Shipping
 * fee locally and shows it (Free when the amount is 0).
 *
 * Data is compiled from the shipping-zone table into window.SHIPPING_RATES
 * (assets/shipping-rates-data.js).
 * Fee = f(postcode, weight): served postcodes only; <22 kg or Sydney-metro
 * free postcodes -> Free; otherwise weight-bracket x postcode tier.
 *
 * The state prefix shown next to the postcode ("NSW 2220") is derived from
 * the Australian postcode -> state ranges (display only).
 */
(function () {
  if (window.ShippingCalculator) return;

  var STORAGE_KEY = 'shipping_calculator_postcode';
  var FREE_WEIGHT_KG = 22;
  var CONTACT_URL = 'https://www.livarahome.com.au/pages/contact-us';

  /* Australian postcode -> state abbreviation (display only). */
  function stateForPostcode(pc) {
    var n = parseInt(pc, 10);
    if (isNaN(n)) return '';
    if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
    if ((n >= 1000 && n <= 1999) || (n >= 2000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
    if (n >= 5000 && n <= 5799) return 'SA';
    if (n >= 6000 && n <= 6797) return 'WA';
    if (n >= 7000 && n <= 7999) return 'TAS';
    if (n >= 800 && n <= 899) return 'NT';
    return '';
  }

  function normalizePostcode(value) {
    var digits = String(value).replace(/[^0-9]/g, '');
    while (digits.length < 4) digits = '0' + digits;
    return digits.slice(0, 4);
  }

  function initWidget(root) {
    if (!root || root.dataset.shippingInitialized) return;
    root.dataset.shippingInitialized = 'true';

    var scope = root.closest('product-info') || root;
    var currency = root.dataset.currencySymbol || '$';
    var toggle = root.querySelector('[data-delivery-toggle]');
    var panel = root.querySelector('[data-delivery-panel]');
    var input = root.querySelector('[data-delivery-input]');
    var dropdown = root.querySelector('[data-delivery-dropdown]');
    var locationEl = root.querySelector('[data-delivery-location]');
    var resultEl = root.querySelector('[data-delivery-result]');
    var resultLabelEl = root.querySelector('[data-delivery-result-label]');
    var feeEl = root.querySelector('[data-delivery-fee]');
    var noteEl = root.querySelector('[data-delivery-note]');
    if (!input) return;

    var activePostcode = '';
    var servedPostcodes = [];

    /* ---------- helpers ---------- */

    function weightKg() {
      var v = parseFloat(root.dataset.weightKg);
      return isNaN(v) ? null : v;
    }

    function quantity() {
      var qtyEl = scope ? scope.querySelector('.quantity__input') : null;
      if (qtyEl) {
        var v = parseInt(qtyEl.value, 10);
        if (!isNaN(v) && v > 0) return v;
      }
      return 1;
    }

    function totalWeightKg() {
      var per = weightKg();
      if (per === null || per <= 0) return null;
      return per * quantity();
    }

    function formatPrice(price) {
      if (price === 0 || price === '0' || price === null || price === undefined) return 'Free';
      var grouped = Number(price).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return currency + grouped;
    }

    function isServed(pc) {
      var data = window.SHIPPING_RATES;
      if (!data) return false;
      if (data.map && data.map[pc]) return true;
      return Array.isArray(data.free) && data.free.indexOf(pc) !== -1;
    }

    function buildPostcodeList() {
      var data = window.SHIPPING_RATES;
      var seen = {};
      var out = [];
      function add(pc) {
        if (pc && !seen[pc]) {
          seen[pc] = 1;
          out.push(pc);
        }
      }
      if (data) {
        if (data.map) Object.keys(data.map).forEach(add);
        if (Array.isArray(data.free)) data.free.forEach(add);
      }
      out.sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
      return out;
    }

    function locationText(pc) {
      var st = stateForPostcode(pc);
      return st ? st + ' ' + pc : pc;
    }

    function feeFor(postcode, totalKg) {
      if (totalKg === null) return { error: 'no-weight' };
      var data = window.SHIPPING_RATES;
      if (!data || !data.map) return { error: 'no-data' };

      var isMetroFree = Array.isArray(data.free) && data.free.indexOf(postcode) !== -1;
      var prices = data.map[postcode];
      if (!isMetroFree && !prices) return { error: 'not-served' };
      if (isMetroFree) return { price: 0, free: true };
      if (totalKg < FREE_WEIGHT_KG) return { price: 0, free: true };

      var idx;
      if (totalKg <= data.brackets[0]) {
        idx = 0;
      } else if (totalKg <= data.brackets[1]) {
        idx = 1;
      } else if (totalKg <= data.brackets[2]) {
        idx = 2;
      } else {
        idx = 3;
      }
      var price = prices[idx];
      if (price === undefined || price === null) return { error: 'not-served' };
      return { price: price, free: price === 0 };
    }

    /* ---------- render helpers ---------- */

    function showResult(label, price) {
      if (noteEl) noteEl.hidden = true;
      if (resultLabelEl) resultLabelEl.textContent = label;
      if (feeEl) feeEl.textContent = formatPrice(price);
      if (resultEl) resultEl.hidden = false;
    }

    function showNote(html) {
      if (resultEl) resultEl.hidden = true;
      if (noteEl) {
        noteEl.innerHTML = html;
        noteEl.hidden = false;
      }
    }

    function hideDropdown() {
      if (dropdown) {
        dropdown.hidden = true;
        dropdown.innerHTML = '';
      }
    }

    function renderDropdown(query) {
      var q = String(query || '').replace(/[^0-9]/g, '');
      if (!q) {
        hideDropdown();
        return;
      }
      var matches = servedPostcodes
        .filter(function (pc) {
          return pc.indexOf(q) === 0;
        })
        .slice(0, 12);
      if (!matches.length) {
        hideDropdown();
        return;
      }
      dropdown.innerHTML = matches
        .map(function (pc) {
          return (
            '<li class="delivery-dropdown__item" data-postcode="' + pc + '">' + locationText(pc) + '</li>'
          );
        })
        .join('');
      dropdown.hidden = false;
    }

    function applyPostcode(raw) {
      var pc = normalizePostcode(raw);
      activePostcode = pc;
      if (input) input.value = pc;
      if (locationEl) locationEl.textContent = locationText(pc);
      try {
        localStorage.setItem(STORAGE_KEY, pc);
      } catch (err) {}

      var fee = feeFor(pc, totalWeightKg());
      if (fee.error === 'no-data') {
        showNote('Delivery rates are not loaded yet. Please try again.');
      } else if (fee.error === 'no-weight') {
        showNote(
          'This item has no weight set, so delivery can’t be calculated. ' +
            'Please <a href="' + CONTACT_URL + '">contact us</a>.'
        );
      } else if (fee.error === 'not-served') {
        showNote(
          'Sorry! Shipping not available for this location.<br>' +
            'Contact <a href="' + CONTACT_URL + '">customer service</a> for more details.'
        );
      } else {
        showResult('Standard Shipping', fee.price);
      }
      hideDropdown();
    }

    /* ---------- events ---------- */

    servedPostcodes = buildPostcodeList();

    if (input) {
      input.addEventListener('focus', function () {
        if (activePostcode && input.value === activePostcode) input.select();
      });

      input.addEventListener('input', function () {
        var digits = input.value.replace(/[^0-9]/g, '');
        if (input.value !== digits) input.value = digits;
        renderDropdown(input.value);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var digits = input.value.replace(/[^0-9]/g, '');
          if (digits) {
            var pc = normalizePostcode(digits);
            if (isServed(pc)) applyPostcode(pc);
            else renderDropdown(digits);
          }
        } else if (e.key === 'Escape') {
          hideDropdown();
        }
      });

      // Keep the dropdown clickable even when the input loses focus first.
      input.addEventListener('blur', function () {
        setTimeout(hideDropdown, 150);
      });
    }

    if (dropdown) {
      dropdown.addEventListener('click', function (e) {
        var item = e.target.closest('[data-postcode]');
        if (item) applyPostcode(item.getAttribute('data-postcode'));
      });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        toggle.classList.toggle('is-collapsed', isExpanded);
        if (!isExpanded && input) input.focus();
      });
    }

    // Recalculate if the shopper changes the quantity.
    var qtyEl = scope ? scope.querySelector('.quantity__input') : null;
    if (qtyEl) {
      qtyEl.addEventListener('change', function () {
        if (activePostcode) applyPostcode(activePostcode);
      });
    }

    // Restore the last checked postcode.
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved && isServed(normalizePostcode(saved))) applyPostcode(saved);
    } catch (err) {}
  }

  function initAll() {
    document.querySelectorAll('[data-shipping-calculator]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme can re-render <product-info> (product swap / re-render).
  document.addEventListener('product-info:loaded', initAll);

  window.ShippingCalculator = { initAll: initAll };
})();